import { LoaderFunctionArgs, useLoaderData, useOutletContext } from "react-router";
import { createProfileNewLinksPageURL } from "#lib/urls";
import { fetchProfileLinks } from "#api/profiles";
import { CardList, ArtistCard } from "#components/cards";
import { ProfilePageSkeleton } from "#components/pages";
import { KemonoLink } from "#components/links";
import { OutletContext } from "./creator-page";

interface IProps {
  links: Awaited<ReturnType<typeof fetchProfileLinks>>;
}

export function ProfileLinksPage() {
  const { links } = useLoaderData() as IProps;
  const { creator } = useOutletContext() as OutletContext;
  const title = "Linked profiles";

  return (
    <ProfilePageSkeleton creator={creator} name={["user", "linked-account"]} title={title}>
      <div id="add-new-link">
        <KemonoLink url={String(createProfileNewLinksPageURL(creator.service, creator.id))}>
          Link another account
        </KemonoLink>
      </div>

      <CardList layout="phone">
        {links.length === 0 ? (
          <p className="subtitle card-list__item--no-results">
            No linked accounts found.
          </p>
        ) : (
          links.map((profile) => (
            <ArtistCard
              key={`${profile.service}-${profile.id}`}
              // TODO: a proper endpoint/component
              // @ts-expect-error the original template is using it this way
              artist={{
                ...profile,
                updated: String(
                  Math.round(new Date(profile.updated).getTime() / 1000)
                ),
                indexed: String(
                  Math.round(new Date(profile.indexed).getTime() / 1000)
                ),
              }}
            />
          ))
        )}
      </CardList>
    </ProfilePageSkeleton>
  );
}

export async function loader({ params }: LoaderFunctionArgs): Promise<IProps> {
  const service = params.service!.trim();
  const creatorId = params.creatorId!.trim();

  const links = fetchProfileLinks(service, creatorId);

  return {
    links: await links,
  };
}
